import { cancelNoshowInMessage, getNoshowDetailInfoByRequestEmail } from "apis/meetings/no-show";
import { TEmailNoShowRepeatReservation } from "./types";

export class MeetingRedirectServices {
  constructor() {}

  //* INFO: 노쇼 예약 취소
  async cancelNoshow(id: string, memberPublicId: string): Promise<void> {
    const res = await cancelNoshowInMessage(id, memberPublicId);
    if (res.success) {
      alert("회의실 반복 예약이 취소되었습니다.");
      window.close();
    } else {
      alert("반복 회의실 예약을 취소할 수 없습니다. 다시 시도해주세요.");
      window.close();
    }
  }

  //* INFO: 노쇼 반복 예약 정보 불러오기
  async getNoshowDetailInfo(id: string): Promise<TEmailNoShowRepeatReservation | null> {
    const detailInfo = await getNoshowDetailInfoByRequestEmail(id);
    if (detailInfo.success && detailInfo.data) return detailInfo.data as TEmailNoShowRepeatReservation;
    else return null;
  }
}
